exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".distributor-image[data-v-15c2d76c]{max-width:100px}@media (max-width: 767px){.distributor-subtitle[data-v-15c2d76c]{font-size:12px}}@media (max-width: 767px){.distributor-title[data-v-15c2d76c]{font-size:20px}}\n", ""]);

// exports
